<div fxLayout="column" fxLayoutAlign="space-around center" class="main">
  <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="20px">
    <div *ngIf="icon">
      <fa-icon [icon]="icon"
               [id]="icon"
               class="fa-lg fa-2x"
               matTooltipPosition="above"
               [ngStyle]="{ color: color }"></fa-icon>
    </div>
    <div class="h3" *ngIf="title">{{ title }}</div>
  </div>
  <div><br /></div>
  <div class="error-message mat-h3" *ngIf="message">{{ message }}</div>
  <div>
    <button type="button" class="col-md-12" mat-button (click)="goToLogin()">
      Back to Login
    </button>
  </div>
</div>
